import Card from "../../componentsNew/Card";
import page from "../../assets/img/page.svg"
import icon from "../../assets/img/icon_wrap.svg"
import Typography from "../../componentsNew/Typography";

export function CardArtigo() {
    const classePadrao = "p-8 border-solid border rounded-full border-[#e4e7ec]"
    return (
        <Card className="p-8 w-full min-h-[54vh] flex flex-col items-center justify-center border-[1px] border-grey border-dashed">
            <div className='flex flex-col items-center justify-center h-full text-center'>
                <div className={`${classePadrao} border-opacity-20`}>
                    <div className={`${classePadrao} border-opacity-40`}>
                        <div className={`${classePadrao} border-opacity-60`}>
                            <div className={`${classePadrao} border-opacity-80`}>
                                <div className={`${classePadrao} border-opacity-100 flex flex-col justify-center items-center`}>
                                    <div className='relative bg-[linear-gradient(0deg,_#edf0f3,_#f9fafb)] rounded-full py-6 px-8'>
                                        <div className='absolute inset-0 rounded-full bg-gradient-radial from-transparent to-gray-100 animate-pulse'></div>
                                        <img src={page} />
                                        <img src={icon} className="absolute translate-y-4 -translate-x-6" />
                                    </div>
                                    <div className="absolute translate-y-1/2 pt-17 flex flex-col items-center justify-center">
                                        <Typography component="h4-bold" >Seu artigo irá aparecer aqui</Typography>
                                        <Typography component="body-card-ia" className="mt-4">Preencha o formulário</Typography>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    )
}
